"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AC;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AC(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "a-c"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M80.983,65l-8.072-4.661,7.8-3.487a2.5,2.5,0,1,0-2.039-4.564l-11.11,4.964L56.6,50.921a6.009,6.009,0,0,0,0-1.842l10.967-6.333L78.672,47.71a2.5,2.5,0,1,0,2.039-4.564l-7.8-3.487L80.983,35a2.5,2.5,0,1,0-2.5-4.33l-8.072,4.661.881-8.5a2.5,2.5,0,0,0-4.973-.516l-1.255,12.1L54.1,44.748a6.647,6.647,0,0,0-1.6-.926V31.163l9.854-7.139a2.5,2.5,0,1,0-2.934-4.048L52.5,24.989V15.667a2.5,2.5,0,0,0-5,0v9.322l-6.92-5.013a2.5,2.5,0,0,0-2.934,4.048L47.5,31.163V43.822a6.647,6.647,0,0,0-1.6.926L34.936,38.416l-1.255-12.1a2.5,2.5,0,0,0-4.973.516l.881,8.5-8.072-4.661a2.5,2.5,0,0,0-2.5,4.33l8.072,4.661-7.8,3.487a2.5,2.5,0,1,0,2.039,4.564l11.11-4.964L43.4,49.079a6.009,6.009,0,0,0,0,1.842L32.437,57.254,21.327,52.29a2.5,2.5,0,1,0-2.039,4.564l7.8,3.487L19.017,65a2.5,2.5,0,1,0,2.5,4.33l8.072-4.661-.881,8.5a2.5,2.5,0,0,0,2.229,2.744,2.277,2.277,0,0,0,.26.014,2.5,2.5,0,0,0,2.484-2.242l1.255-12.1L45.9,55.252a6.644,6.644,0,0,0,1.6.925v12.66l-9.854,7.139a2.5,2.5,0,1,0,2.934,4.048l6.92-5.013v9.322a2.5,2.5,0,0,0,5,0V75.011l6.92,5.013a2.5,2.5,0,0,0,2.934-4.048L52.5,68.837V56.177a6.644,6.644,0,0,0,1.6-.925l10.967,6.332,1.255,12.1A2.5,2.5,0,0,0,68.8,75.928a2.277,2.277,0,0,0,.26-.014,2.5,2.5,0,0,0,2.229-2.744l-.881-8.5,8.072,4.661a2.5,2.5,0,1,0,2.5-4.33Z"
  }))));
}